import React, { useEffect, useState } from 'react';
import PdfViewer from './Pages/PdfViewer.js';

function App() {
  const params = new URLSearchParams(window.location.search);

  const restaurantName = params.get('restaurantName') || '';
  const restaurantId = params.get('restaurantId') || '';

  // Set globally for easy access
  window.restaurantName = restaurantName;
  window.restaurantId = restaurantId;

  // Set the document title globally
  useEffect(() => {
    document.title = `${restaurantName && restaurantName.trim() !== "" ? restaurantName : "dit restaurant"}`;
  }, [restaurantName]);

  return (
    <>
      <PdfViewer restaurantId={restaurantId} />
    </>
  );
}

export default App;
